<template>
  <main-layout>

    <div slot="left-side">
      <menubar screenIdParam="M-06-78"></menubar>
    </div>

    <!--  メインページ 開始  -->
    <el-row slot="header">
      <head-title>
        <label slot="title">
          {{ $t("label.ownerSetting.title") }}
        </label>
        <lvory-but
          slot="cancel"
          class="header-clear-btn"
          @click="backPage">
          {{ $t("button.common.cancel") }}
        </lvory-but>
      </head-title>
    </el-row>

    <div slot="body">
      <div>
        <div class="title-box" >
          <div class="owner-main-title">
            {{$t("title.system.owner.detail")}}
          </div>
        </div>
        <div>
          <div class="setting-header-name" style="margin-top: 40px;">
            基本設定
          </div>

          <hr class="hr-delimiter"/>
          <div class="flex-div">
            <!-- マルシェ設定データ(CSV)ファイル取り込み -->
            <button-index
              @click="machineImport"
              class="setting-btn click-item "
              v-show="this.$IsShowButFun('010205', ownerDetail.deleteFlag, true) ">
              {{ $t("button.system.owner.machineImport") }}
            </button-index>

            <!-- マルシェ設定データ(CSV)ダウンロード -->
            <button-index
              @click="machineExport"
              class="setting-btn click-item "
              v-show="this.$IsShowButFun('010206', ownerDetail.deleteFlag, true) ">
              {{ $t("button.system.owner.machineExport") }}
            </button-index>

            <!-- SSO連携情報 -->
            <button-index
              @click="linkSsoDetail"
              class="setting-btn click-item "
              v-show="this.$IsShowButFun('010207', ownerDetail.deleteFlag, true) && ssoBtnIsShow">
              SSO連携情報
            </button-index>

            <!-- オーナーSSO設定をテナントに引継ぐ -->
            <div
              v-for="(item, index) in newSettingList"
              :key="index"
              v-auth="{ auth: '010209' }"
              v-show="(item.code == '010110')"
              class="setting-item">
              <div>{{ item.name }}</div>
              <div class="on-switch owner-sso-switch-style" @click="updateOwnerSettingInfoApi(true)">
                ON
                <el-switch :disabled="true" v-model="item.value"  />
              </div>
            </div>

            <!-- リソース連携設定編集 -->
            <button-index
              @click="calendarEdit"
              class="setting-btn click-item"
              v-show="this.$IsShowButFun('010614', ownerDetail.deleteFlag, true) && resourceBtnIsShow && !ownerDetail.outlookSyncFlag">
              {{ $t("button.system.owner.calendarEdit") }}
            </button-index>

            <!-- よくある質問カテゴリの管理 -->
            <button-index
              @click="faqSettingManage"
              class="setting-btn click-item"
              v-show="this.$IsShowButFun('010313', ownerDetail.deleteFlag, true)">
              {{ $t("button.system.owner.faqsManagingCategories") }}
            </button-index>

             <!-- リンク設定 -->
            <button-index
              class="setting-btn click-item"
              @click="linkSetting"
              v-auth="{ auth: '010215' }">
              {{ $t("label.ownerSetting.linkSetting") }}
            </button-index>

            <!-- class="setting-item" -->
            <div
              v-for="(item, index) in newSettingList"
              :key="index"
              v-auth="{ auth: '010209' }"
              v-show="item.name == 'オーナー管理者での予約' "
              class="setting-item">
              <div>{{ item.name }}</div>
              <div class="on-switch">
                ON
                <el-switch v-model="item.value" @change="updateOwnerSettingInfoApi(false)" />
              </div>
            </div>

            <!-- Mapxus管理 -->
            <button-index
              class="setting-btn click-item"
              @click="mapxusManage"
              v-if="ownerDetail.locationFuncFlag"
              v-auth="{ auth: '010222' }">
              {{ $t("label.ownerSetting.mapxusManage") }}
            </button-index>

            <button-index
              class="setting-btn click-item"
              @click="outlookPortable"
              v-if="ownerDetail.outlookSyncFlag">
              {{ $t("label.ownerSetting.outlookPortable") }}
            </button-index>
          </div>
        </div>

        <div class="setting-header-name" style="margin-top: 64px;">
          {{ $t("label.ownerSetting.displaySetting") }}
        </div>

        <hr class="hr-delimiter" />

        <div class="flex-div">
          <!-- カラーモード設定 -->
          <button-index
            v-if="showColorModelMenuFlg"
            class="setting-btn click-item"
            @click="changeColorModel"
            :disabled="!showColorModelMenuFlg"
            v-auth="{ auth: '010211' }">
            {{ $t("label.ownerSetting.colorModelSetting") }}
          </button-index>

          <!-- メニュー名の変更 -->
          <button-index
            class="setting-btn click-item"
            @click="changeMenu"
            v-auth="{ auth: '010213' }">
            {{ $t("label.ownerSetting.changeMenuName") }}
          </button-index>

          <!-- class="setting-item" -->
          <div
            v-for="(item, index) in newSettingList"
            :key="index"
            v-auth="{ auth: '010209' }"
            v-show="(item.name != 'オーナー管理者での予約' && item.code != '010110')"
            class="setting-item">
            <div>{{ item.name }}</div>
            <div class="on-switch">
              ON
              <el-switch v-model="item.value" @change="updateOwnerSettingInfoApi(false)" />
            </div>
          </div>


        </div>

        <div v-if="ownerDetail.creditFuncFlag" class="setting-header-name m-top-5">
          クレジット払い / 決済設定
        </div>

        <hr v-if="ownerDetail.creditFuncFlag"  class="hr-delimiter" />

        <div v-if="ownerDetail.creditFuncFlag"  class="flex-div">
          <!-- && this.$authBuildFuncCodeCheck('02070') -->
          <!-- クレジット接続先設定 -->
          <button-index
            class="setting-btn click-item"
            @click="creditDestinationSetting"
            v-show="this.$IsShowButFun('010219', ownerDetail.deleteFlag, true)">
            {{ $t("button.system.building.detail.destinationSetting") }}
          </button-index>
          <!-- 消費税テンプレート -->
          <button-index
            class="setting-btn click-item"
            @click="saleTaxTemplate"
            v-auth="{ auth: '010220' }">
            消費税テンプレート
          </button-index>
        </div>
      </div>

      <!-- よくある質問カテゴリ編集 -->
      <categories-manage-popup :visible.sync="isShowCategoriesManagePopup" :owner-id="ownerDetail.ownerId" />

      <loading-dialog :dialogVisible="showLoading" />

      <dialog-index
        :centerDialogVisibleParam.sync="isDialogShowFlag"
        :msgParam="msg"
        @on-isPassParam="ownerConfirm"
        @on-cancel="onCancel"/>
    </div>
  </main-layout>
</template>

<script>
import Menubar from "@/components/leftmenu/DashBoard"
import LvoryBut from "@/components/common/generalButton/LvoryBut"
import HeadTitle from "@/components/common/head/head"
import MainLayout from "@/layout/NewDesignLayout"
import errorCodeMsg from "@/utils/error-code-msg"
import statusErrorCodeMsg from "@/utils/status-error-msg"
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import SystemManageApi from "@/api/SystemManageApi"
import buttonIndex from "@/components/common/sp-smart-button/index"
import fileDownloader from "@/utils/file-downloader";
import CategoriesManagePopup from "@/components/system/popup/CategoriesManagePopup";
import DialogIndex from "@/components/common/el-dialog-prompt-owner";

export default {
  name: "OwnerSettingEdit",
  components: {
    Menubar: Menubar,
    LvoryBut: LvoryBut,
    HeadTitle: HeadTitle,
    MainLayout: MainLayout,
    LoadingDialog: LoadingDialog,
    buttonIndex,
    CategoriesManagePopup,
    DialogIndex
  },
  data () {
    return {
      showColorModelMenuFlg: false,
      showLoading: false,
      lightFlag:false,
      orgId: null,
      ownerDetail: null,
      shareDisplayFlag: false,
      form: {
        settingList:[]
      },
      settingAllList:[],
      isShowCategoriesManagePopup: false,
      resourceBtnIsShow: true,
      ssoBtnIsShow: true,
      ssoTenantIsShow: false,
      newSettingList:[],
      alreadyConfirmedFlag: false,
      msg: "テナントのSSOが解除されます\nよろしいですか？",
      isDialogShowFlag: false
    }
  },
  created () {
    this.$authCheck("010209")
    if (this.$IsOwnerManager()) {
      this.ssoBtnIsShow = false
      this.resourceBtnIsShow = false
    } else {
      this.ssoBtnIsShow = true
      this.resourceBtnIsShow = true
    }
    this.orgId = this.$route.query.orgId
    const ownerDetailStr = this.$route.query.ownerDetail;
    if (ownerDetailStr) {
      this.ownerDetail = JSON.parse(ownerDetailStr);
    }
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/owners/search",
        title: "label.router.owner",
      },
      {
        path: "",
        title: "label.router.ownerSetting",
      }
    ]
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
  },
  mounted () {
    this.showBtn()
    this.getOwnerSettingInfoApi()

  },
  watch: {
    form: {
      deep: true,
      handler () {
        this.checkColorModelMenu()
        this.createNewSettingList()
      }
    }
    ,
    ssoTenantIsShow: {
      handler () {
        this.createNewSettingList()
      }
    }
  },
  methods: {
    createNewSettingList(){
      if (!this.ssoTenantIsShow) {
        this.newSettingList = this.form.settingList.filter(a => a.code != '010110')
      } else {
        this.newSettingList = this.form.settingList
      }
    },
    showBtn(){

      SystemManageApi.getSystemOrgSso(this.orgId)
      .then(({data}) => {
        if (data.body != null && data.body != undefined && data.body != "") {
          if (!this.$IsNullOrEmpty(data.body.policyId) || !this.$IsNullOrEmpty(data.body.azureAdUUID)) {
            this.ssoTenantIsShow = true
            if (this.$IsOwnerManager()) {
              this.ssoBtnIsShow = true
            }
          } else {
            this.ssoTenantIsShow = false
            if (this.$IsOwnerManager()) {
              this.ssoBtnIsShow = false
            }
          }
        } else {
          this.ssoTenantIsShow = false
          if (this.$IsOwnerManager()) {
            this.ssoBtnIsShow = false
          }
        }
      })
      .catch(() => {
        this.ssoTenantIsShow = false
        if (this.$IsOwnerManager()) {
          this.ssoBtnIsShow = false
        }
      })
      .finally(() => {
        this.showLoading = false
      })

      if (this.$IsOwnerManager()) {

        SystemManageApi.getResource(this.orgId)
        .then(({data}) => {
          if (data.body != null && data.body != undefined && data.body != "") {
            if (data.body.googleResourceAuthInfo != null && data.body.googleResourceAuthInfo != undefined && data.body.googleResourceAuthInfo != "") {
              this.resourceBtnIsShow = true
            }

            if (data.body.outlookResourceAuthInfo != null && data.body.outlookResourceAuthInfo != undefined && data.body.outlookResourceAuthInfo != "") {
              this.resourceBtnIsShow = true
            }
          } else {
            this.resourceBtnIsShow = false
          }

        })
        .catch(() => {
          this.resourceBtnIsShow = false
        })
        .finally(() => {
          this.showLoading = false
        })
      }
    },
      /**
     * 販売マシン導入
     */
     machineImport() {
      // TODO 販売マシン導入画面跳转
      this.$router.push({
        name: "system-owner-salesMachine",
        params: {
          ownerId: this.ownerDetail.ownerId,
          ownerExId: this.ownerDetail.ownerExId,
          ownerName: this.ownerDetail.ownerName
        },
      });
    },

    /**
     * 販売マシン出力
     */
     machineExport() {
      // TODO 调用 販売マシン出力 Api
      SystemManageApi.ownerVendingExport(this.ownerDetail.ownerId,
      )
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then((resp) => {
        fileDownloader(resp)
      }).finally(() => {
        this.showLoading = false;
      });
    },

    /**
     * SSO連携情報
     */
    linkSsoDetail () {
      this.$router.push({
        name: "system-sso-detail",
        query: {
          pageType: '1',
          ownerId: this.ownerDetail.ownerId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },

    /**
     * リソース連携設定編集
     */
     calendarEdit() {
      this.$router.push({
        name: "system-resource-edit",
        query: {
          pageType: '1',
          orgId: this.ownerDetail.ownerId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },

    // よくある質問カテゴリの管理
    faqSettingManage() {
      this.isShowCategoriesManagePopup = true
    },

    checkColorModelMenu(){
      if (this.$IsSBManager()) {
        this.showColorModelMenuFlg = true
      }
      let selected = this.settingAllList.find(item => item.code == "070110" && item.value)
      if (this.$IsOwnerManager()) {
        if (selected != undefined && selected != null) {
          if (selected.code) {
            this.showColorModelMenuFlg = true
          }
        }
      }
    },
    getOwnerSettingInfoApi () {
      this.showLoading = true
      SystemManageApi.getOwnerSettingInfo(this.orgId)
        .then(({data}) => {
          if (!statusErrorCodeMsg(data.statusCode, this)) {
            return
          }
          this.settingAllList = []
          this.form.settingList = []
          if (data.body != null && data.body != undefined && data.body != "") {

            this.settingAllList = data.body
            this.lightFlag = false
            for (const item of data.body) {
              if ((item.code == "070110") && !this.$IsSBManager()) {
                if(item.value){
                  this.lightFlag = true
                }
                continue
              }

              this.form.settingList.push(item)
            }
          }
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.showLoading = false
        })
    },

    updateOwnerSettingInfoApi (flag) {
      var functions = []
      for (var i = 0; i < this.newSettingList.length; i++) {
        if (this.newSettingList[i].value) {
          functions.push(this.newSettingList[i].code);
        }
      }
      if(this.lightFlag){
        functions.push("070110");
      }
      if(flag){
        if(functions.includes('010110')){
          functions = functions.filter(f => f !== '010110');
        }else{
          functions.push('010110');
        }
      }

      let request = {
        functions: functions,
        alreadyConfirmedFlag: this.alreadyConfirmedFlag
      }

      this.showLoading = true
      SystemManageApi.updateOwnerSettingInfo(this.orgId, request)
        .then(({data}) => {

          if (data.statusCode == 'Failure.TenantInheritOwnerWarn') {
            this.isDialogShowFlag = true
          } else {
            if (!statusErrorCodeMsg(data.statusCode, this)) {
              return
            }

            if (data.statusCode == "Success") {
              this.$messageIotSuccess(this.$t("message.common.save"))
            }
            this.getOwnerSettingInfoApi()
          }
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.showLoading = false
        })
    },

    onCancel(param){
      this.isDialogShowFlag = false
      if (param) {
        this.getOwnerSettingInfoApi()
      }
    },

    ownerConfirm(param){
      this.isDialogShowFlag = false
      if (param) {
        this.alreadyConfirmedFlag = true
        this.updateOwnerSettingInfoApi(true)
      }
    },

    backPage () {
      this.$router.push({
        name: "system-owner-detail",
        params: {
          ownerId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },

    changeMenu () {
      this.$router.push({
        name: "system-menu-change-edit",
        params: {
          ownerId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },

    linkSetting() {
      this.$router.push({
        name: "link-setting",
        query: {
          ownerId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },

    saleTaxTemplate() {
      this.$router.push({
        name: "saleTax-template",
        query: {
          ownerId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },

    // クレジット接続先設定
    creditDestinationSetting () {
      this.$router.push({
        name: "credit-destination-setting",
        query: {
          orgId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      });
    },

    changeColorModel() {
      this.$router.push({
        name: "system-owner-color-model",
        query: {
          ownerId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },

    mapxusManage(){
      this.$router.push({
        name: "mapxus-manage-detail",
        query: {
          orgId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },
    outlookPortable(){
      this.$router.push({
        name: "system-outlook-edit",
        query: {
          pageType: '1',
          orgId: this.orgId,
          ownerDetail: JSON.stringify(this.ownerDetail)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">

.title-box{
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.owner-main-title{
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 30px;
  font-weight: 300;
  line-height: 45px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: #525250;
}

.flex-div{
  width: 1028px;
  display: flex;
  flex-wrap: wrap;
}

.header-clear-btn::v-deep {
  .my-button {
    width: 152px;
    height: 32px;
  }
}

.setting-btn,
.setting-item,
.setting-header-name {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 16px;
  font-weight: 300;
  line-height: 24px;
  color: #525250;
}

.setting-btn,
.setting-item {
  width: 460px;
  height: 60px;
  border-radius: 8px;
  background-color: #F2F2ED;
  box-shadow: -4px -4px 5px #FFFFFF, 4px 4px 8px #E6E6D8;
  display: flex;
  align-items: center;
  padding-left: 28px;
  padding-right: 16px;
  margin-top: 32px;
  margin-right: 22px;
  margin-left: 0px!important;
}

.setting-item:hover {
  opacity: 0.6;
}

.setting-item.click-item {
  cursor: pointer;
}

.on-switch {
  margin-left: auto;
}
.setting-btn:disabled {
  background: #F2F2ED;
  opacity: 0.5;
  color: rgba(82, 82, 80, 0.6) !important;
}
.hr-delimiter {
  margin-top: 12px;
  background-color: #D4D4D4 !important;
}

.owner-sso-switch-style{
  ::v-deep.el-switch.is-disabled{
    opacity: 1 !important;
  }
  ::v-deep.el-switch.is-disabled .el-switch__core{
    cursor: pointer !important;
  }
}

</style>
